var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.55,31.6H25.5V21.9L29.45,26,31.6,23.8,24,16.2l-7.6,7.6L18.5,26l4.05-4.05ZM7,40a2.88,2.88,0,0,1-2.1-.9A2.88,2.88,0,0,1,4,37V11a2.88,2.88,0,0,1,.9-2.1A2.88,2.88,0,0,1,7,8H41a2.88,2.88,0,0,1,2.1.9A2.88,2.88,0,0,1,44,11V37a3.08,3.08,0,0,1-3,3Zm0-3H41V11H7Zm0,0v0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide);
export default __webpack_public_path__ + "static/media/slide.f982f4be1e8646d9bc1a5af465c7ba54.svg";
export { ForwardRef as ReactComponent };